module.exports = __webpack_public_path__ + "static/media/power-stering-fluid-exchange-red.c2def367.svg";